globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modules = appCustomerSpace.Modules || {};
appCustomerSpace.Modules.Account = appCustomerSpace.Modules.Account || {};

appCustomerSpace.Modules.Account.PlatformIframe = (function() {

  function PlatformIframe($iframe) {
    this.$body            = $("body");
    this.$iframe          = $iframe;
    this.$iframeContainer = this.$iframe.closest('.iframe-container');

    this.init();
  }

  PlatformIframe.initIframes = function(){
    $('iframe.embed-crm-customer-space').each(function(){
      new PlatformIframe($(this));
    });
  }

  PlatformIframe.prototype = {
    init: function() {
      var _this = this;

      appCustomerSpace.Loader().start({ $container: _this.$iframeContainer });

      _this._embedCrmCustomerSpace();
    },
    _embedCrmCustomerSpace: function() {
      var _this = this;

      window.addEventListener('message', function(e) {
        if(e.origin == _this.$iframe.data('origin') && e.data) {
          try {
            var data = JSON.parse(e.data),
              iframeHeight = data.contentHeight;

            if(iframeHeight) {
              appCustomerSpace.Loader().stop({ $container: _this.$iframeContainer });
              _this.$iframe.height(iframeHeight + 'px');
            }
          } catch(err) {
            if(e.data == 'refresh_crm_customer_space_authentication_token') {
              var ajaxUrl = _this.$iframe.data('refresh-crm-customer-space-authentication-token-ajax-url');

              if(ajaxUrl) {
                $.get(ajaxUrl, function(data) {
                  if(data.token) {
                    _this.$iframe.attr('src', _this.$iframe.attr('src').replace(/\?.*/, '?token=' + data.token))
                  }
                });
              }
            }
          }
        }
      });

      _this.$iframe.attr('src', _this.$iframe.data('src'));
    }
  }

  return PlatformIframe;
})();
